import React from 'react';
import Routes from '../../consts/Routes';
import CTButton from './CTButton';

const LoginButton = () => {
  return <CTButton pushParams={Routes.LOGIN}>Log In</CTButton>;
};

export default LoginButton;
